var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowO1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 23,
    viewBox: "0 0 30 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5653 12.0906C29.1803 11.5055 29.2276 10.557 28.671 9.97191L19.6008 0.437827C19.0442 -0.147232 18.0944 -0.147232 17.4794 0.437827C16.8645 1.02289 16.8171 1.97145 17.3737 2.55651L25.4362 11.0312L16.528 19.506C15.9131 20.091 15.8657 21.0396 16.4223 21.6247C16.9789 22.2097 17.9287 22.2097 18.5437 21.6247L28.5653 12.0906ZM0.0751953 11.0312L0.000446914 12.5294L27.4827 12.5294L27.5575 11.0312L27.6322 9.53311L0.149944 9.53311L0.0751953 11.0312Z",
    fill: "#FE572A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowO1);
export default __webpack_public_path__ + "static/media/Arrow_O1.c0a4d585dd76e8c4d0c5fb3210cead50.svg";
export { ForwardRef as ReactComponent };